import {
  Slot,
  Slottable
} from "../../../chunk-5DWHOSR4.mjs";
import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Link/Link.tsx
import * as React from "react";
import { MdArrowOutward } from "react-icons/md";
import { useComponentsTranslation } from "../../../i18n/useComponentsTranslation.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
var linkVariants = cva("buyscout-link", {
  variants: {
    variant: {
      default: "",
      accent: "buyscout-link--accent",
      muted: "buyscout-link--muted",
      quiet: "buyscout-link--quiet"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
var graphemes = new Intl.Segmenter(void 0, { granularity: "grapheme" });
function splitLastSegment(children) {
  const parts = React.Children.toArray(children);
  const last = parts.at(-1);
  if (typeof last !== "string" && typeof last !== "number") return [children, ""];
  const text = String(last);
  const lastGrapheme = [...graphemes.segment(text.trimEnd())].at(-1);
  if (!lastGrapheme) return [children, ""];
  return [[...parts.slice(0, -1), text.slice(0, lastGrapheme.index)], text.slice(lastGrapheme.index)];
}
function Link({ ref, variant, asChild = false, external = false, className, children, target, rel, ...props }) {
  const { t } = useComponentsTranslation();
  const Comp = asChild ? Slot : "a";
  const [head, lastSegment] = splitLastSegment(children);
  return /* @__PURE__ */ jsxs(
    Comp,
    {
      ref,
      className: linkVariants({ variant, className }),
      target: external ? "_blank" : target,
      rel: external ? rel ?? "noopener noreferrer" : rel,
      ...props,
      children: [
        /* @__PURE__ */ jsx(Slottable, { children: external && !asChild ? head : children }),
        external && /* @__PURE__ */ jsxs("span", { className: "buyscout-link__tail", children: [
          !asChild && lastSegment,
          /* @__PURE__ */ jsx(MdArrowOutward, { "aria-hidden": true, className: "buyscout-link__external" }),
          /* @__PURE__ */ jsx("span", { className: "buyscout-link__hint", children: t("link.opensInNewTab") })
        ] })
      ]
    }
  );
}
Link.displayName = "Link";
export {
  Link
};
//# sourceMappingURL=Link.mjs.map